import {
  HIDE_MODAL,
  SHOW_MODAL,
} from '@actions/loadingModal';

const defaultState = {
  isVisible: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_MODAL: {
      return {
        ...state,
        isVisible: true,
      };
    }
    case HIDE_MODAL: {
      return {
        ...state,
        isVisible: false,
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/loadingModal.js